/* eslint-disable react-hooks/exhaustive-deps */
import React, { useEffect, useState } from "react";
import { CircularProgress } from "@material-ui/core";
import { getRequest, putRequest } from "utils/request";
import ClientForm from "components/ClientForm";

import "../style.css";

export default function EditClient({
  CustomerAllData,
  setCustomer,
  skuteTicket,
  skuteChannelTicket,
  ticketData,
}) {
  const [loading, setLoading] = useState(false);
  const [CustomerData, setCustomerData] = useState("");
  const [update, setUpdate] = useState(0);


  const loadClient = async () => {
    setLoading(true);
    //BUSCA DADOS DO CLIENTE
    const ReturnGet = await getRequest(
      `/customers/${CustomerAllData.id}?offset=0&limit=1000&text`
    );
    if (ReturnGet.success) {
      setCustomerData(ReturnGet.data);
    }
    setLoading(false);
  }

  useEffect(() => {
    loadClient();
  }, [CustomerAllData, update]);

  const handleConfirm = async (customer) => {
    setLoading(true);

    //SALVA ALTERAÇÕES DO CLIENTE
    await putRequest(`/customers/${CustomerAllData.id}`, customer)            
    .then(function (response) {
      if (response.success) {
        setCustomer(response.data);
      }
    });
    setLoading(false);

    setUpdate(update + 1);
  };

  return (
    <div className="box-area-edit-client-chat-page">
      {!loading ? (
        <ClientForm
          CustomerData={CustomerData}
          ticketData={ticketData}
          skuteChannelTicket={skuteChannelTicket}
          handleConfirm={handleConfirm}
          skuteTicket={skuteTicket}
        />
      ) : (
        <div className="area-loading">
          <CircularProgress />
        </div>
      )}
    </div>
  );
}
